/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import useMediaUpload from '../../../hooks/useMediaUpload'

import iconDropDown from "../../../assets/images/icondropdown.svg";
import link from "../../../assets/images/link.svg";
import featured from "../../../assets/images/featured.svg";
import more from "../../../assets/images/more.svg";
import search from "../../../assets/images/icon-search.svg";

export const RightSidebar = ({
  styles,
  setShowUploadMediaPopup,
  setUploadMediaPopupTab,
  setUploadMediaPopupFor,
  productData,
  setProductData,
  changeSlug,
  errorMessage,
  setErrorMessage,
  published,
  draft,
  isPublishedOpen,
  setIsPublishedOpen,
  isDraftOpen,
  setIsDraftOpen,
  isLoading,
  isDraftLoading,
  handlePublish,
  handleDraft,
  handleChangeToDraft,
  handleChangeToPublish,
  productId,
  setIsDraftLoading,
  setIsLoading,
  validateDraftProduct,
  handleSlugChange,
  categoryList,
  brandList,
  selectedCategories,
  setSelectedCategories,
  selectedBrandCategories,
  setSelectedBrandCategories,
  handleSingleDelete,
  selectedFeatureImage
}) => {

  const brandDropdownRef = useRef()
  const dotsRef = useRef(null);
  const dotsMobileRef = useRef(null);
  const dropdownRef = useRef()

  const [isOpenSlugDropdown, setOpenSlugDropdown] = useState(true);
  const [isOpenFeatureImageDropdown, setOpenFeatureImageDropdown] = useState(true);
  const [isOpenPriceDropdown, setOpenPriceDropdown] = useState(true);
  const [isOpenStockDropdown, setOpenStockDropdown] = useState(true);
  const [isOpenSKUDropdown, setOpenSKUDropdown] = useState(true);
  const [isOpenUnitDropdown, setOpenUnitDropdown] = useState(true);
  const [isOpenShowProduct, setOpenShowProduct] = useState(true);
  const [isOpenCategoryDropdown, setOpenCategortDropdown] = useState(true);
  const [isOpenBrandCategoryDropdown, setOpenBrandCategoryDropdown] = useState(true);

  const [searchCategory, setSearchCategory] = useState('');
  const [searchBrand, setSearchBrand] = useState('');
  const [openBrand, setOpenBrand] = useState(false);

  const [isImageDragging, setIsImageDragging] = useState(false);
  const [featuredImageArray, setFeaturedImageArray] = useState(selectedFeatureImage ? [selectedFeatureImage] : []);

  const fileList = {
    'image/jpeg': true,
    'image/png': true,
    'image/jpg': true
  };

  const { handleMeidaUpload } = useMediaUpload(setFeaturedImageArray, null, fileList);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (brandDropdownRef.current && !brandDropdownRef.current.contains(event.target)) {
        setOpenBrand(false);
      }
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenBrand(false);
      }
    };

    // Attach the event listener when the component mounts
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (!e.target) return;

      if (isDraftOpen && !e.target.closest(".publishedButtonsList") && !e.target.closest(".actionDots")) {
        setIsDraftOpen(false);
      }
      if (isPublishedOpen && !e.target.closest(".publishedButtonsList") && !e.target.closest(".actionDots")) {
        setIsPublishedOpen(false);
      }
    };

    document.addEventListener("mousedown", checkIfClickedOutside);

    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [isDraftOpen, isPublishedOpen]);

  useEffect(() => {
    if (featuredImageArray.length > 0) {
      setProductData(prev => ({ ...prev, image: featuredImageArray[0]?.id }));
    } else {
      setProductData(prev => ({ ...prev, image: null }));
    }
  }, [featuredImageArray]);

  const toggleDropdownSlug = () => {
    setOpenSlugDropdown(!isOpenSlugDropdown);
  };
  const toggleDropdownFeatureImage = () => {
    setOpenFeatureImageDropdown(!isOpenFeatureImageDropdown);
  };
  const toggleDropdownCategoryImage = () => {
    setOpenCategortDropdown(!isOpenCategoryDropdown);
  };
  const toggleDropdownPrice = () => {
    setOpenPriceDropdown(!isOpenPriceDropdown);
  };
  const toggleDropdownStock = () => {
    setOpenStockDropdown(!isOpenStockDropdown);
  };
  const toggleDropdownSKU = () => {
    setOpenSKUDropdown(!isOpenSKUDropdown);
  };
  const toggleDropdownUnit = () => {
    setOpenUnitDropdown(!isOpenUnitDropdown);
  };
  const toggleDropdownShowProduct = () => {
    setOpenShowProduct(!isOpenShowProduct);
  };
  const toggleDropdownBrandCategoryImage = () => {
    setOpenBrandCategoryDropdown(!isOpenBrandCategoryDropdown);
  };

  const handleCheckboxChange = (value) => {
    if (selectedCategories.includes(value)) {
      setSelectedCategories(selectedCategories.filter((v) => v !== value));
    } else {
      setSelectedCategories([...selectedCategories, value]);
    }
  };

  const handleBrandCategoryCheckboxChange = (value) => {
    setSelectedBrandCategories(value);
  };

  const handleFileDragOver = (e) => {
    e.preventDefault();
    if (!isImageDragging) {
      setIsImageDragging(true);
    }
  };

  const handleFileDragLeave = (e) => {
    e.preventDefault();
    setIsImageDragging(false);
  };

  const handleFeatureImageDrop = async (e) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    const maxSizeInBytes = 128 * 1024 * 1024; // 128MB
    const allowedFileTypes = ['image/jpeg', 'image/png', 'image/jpg'];

    // Filter files based on type and size, take only the first valid file
    const validFiles = Array.from(files).filter(file => {
      if (!allowedFileTypes.includes(file.type)) {
        console.log(`File ${file.name} is not an allowed type. Only JPG, JPEG, and PNG are allowed.`);
        return false;
      }
      if (file.size > maxSizeInBytes) {
        console.log(`File ${file.name} exceeds the maximum size of 128MB.`);
        return false;
      }
      return true;
    }).slice(0, 1); // Take only the first valid file

    handleMeidaUpload(validFiles);
    setIsImageDragging(false);
  };

  const filteredBrands = (brandList || []).filter((brand) =>
    (brand?.name || "")
      .toLowerCase()
      .includes((searchBrand || "").toLowerCase())
  );

  const filteredCategories = (categoryList || []).filter((category) => {
    return (
      category?.level !== 0 &&
      (category?.name || "")
        .toLowerCase()
        .includes((searchCategory || "").toLowerCase())
    );
  });


  return (
    <div className={styles.newpageRight}>
      <div className={styles.buttonsDesktop}>
        {(published === false && draft === false) ? (
          <div className={styles.newpageRightButtons}>
            <button
              className={`${styles.primaryButton} ${styles.publishButton}`}
              onClick={handlePublish}
            >
              {isLoading ? (
                <div className={`ringLoader loaderContinue`}></div>
              ) : (
                <p>Publish</p>
              )}
            </button>
            <button
              className={`${styles.secondaryButton} ${styles.draftButton} draft`}
              onClick={() => {
                if (!validateDraftProduct()) return;
                setIsDraftLoading(true);
                handleDraft();
              }}
            >
              {isDraftLoading ? (
                <div className={`ringLoader loaderContinue`}></div>
              ) : (
                <p>Save as draft</p>
              )}
            </button>
          </div>
        ) : published === true ? (
          <div>
            <div className={styles.newpageRightButtons} ref={dotsRef}>
              <button
                className={`${styles.primaryButton} ${styles.updatePagebtn}`}
                onClick={handlePublish}
              >
                {isLoading ? (
                  <div className={`ringLoader loaderContinue`}></div>
                ) : (
                  <p>Update</p>
                )}
              </button>
              <button
                className={`${styles.newpageMoreButtons} ${styles.secondaryButton}`}
                onClick={() => setIsPublishedOpen(!isPublishedOpen)}
              >
                <img src={more} alt="Dots" className={`actionDots ${styles.actionDots}`} />
              </button>
              {isPublishedOpen && productId && (
                <div className={`publishedButtonsList ${styles.publishedButtonsList}`}>
                  <ul>
                    <li
                      className={styles.publishLi}
                      onClick={handleChangeToDraft}
                    >
                      Change to draft
                    </li>
                    <li
                      className={styles.publishLi}
                      onClick={handleSingleDelete}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              )}
            </div>
            <p className={styles.publishStatus}>
              Status: <span>{productData?.status?.charAt(0).toUpperCase() + productData?.status?.slice(1)}</span>
            </p>
          </div>
        ) : draft === true ? (
          <div>
            <div className={styles.newpageRightButtons} ref={dotsRef}>
              <button
                className={`${styles.primaryButton} ${styles.updateDraftButton}`}
                onClick={() => { if (!validateDraftProduct()) return; setIsLoading(true); handleDraft(); }}
              >
                {isLoading ? (
                  <div className={`ringLoader loaderContinue`}></div>
                ) : (
                  <p>Update Draft</p>
                )}
              </button>
              <button
                className={`${styles.newpageMoreButtons} ${styles.secondaryButton}`}
                onClick={() => setIsDraftOpen(!isDraftOpen)}
              >
                <img src={more} alt="Dots" className={`actionDots ${styles.actionDots}`} />
              </button>
              {isDraftOpen && productId && (
                <div className={`publishedButtonsList ${styles.publishedButtonsList}`}>
                  <ul>
                    <li
                      className={styles.publishLi}
                      onClick={handleChangeToPublish}
                    >
                      Publish
                    </li>
                    <li
                      className={styles.publishLi}
                      onClick={handleSingleDelete}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              )}
            </div>
            <p className={styles.publishStatus}>
              Status: <span className={styles.draftStatus}>Draft</span>
            </p>
          </div>
        ) : (
          ''
        )}
      </div>
      <div className={`${styles.newPageRightRow} ${styles.newPageRightRowURL}`} >
        <div className={`${styles.newPageRightTitle} ${styles.iconDropWrap}`} onClick={toggleDropdownSlug}>
          <span>URL address</span>
          <div className={styles.dropdownIcon}>
            <img src={iconDropDown} alt="dropdown" />
          </div>
        </div>

        <div className={`${styles.contentDrop} ${isOpenSlugDropdown ? `${styles.expanded}` : `${styles.collapse}`}`}>
          <div className={`${styles.adressInputBlock} ${styles.urlInput}`}>
            <img className={styles.adressLink} src={link} alt="Search" />
            <input
              type="text"
              name="slug"
              placeholder="URL"
              autoComplete="off"
              value={productData?.slug}
              onChange={handleSlugChange}
              onBlur={(e) => {
                changeSlug(e.target.value)
              }}
            />
          </div>
          {errorMessage?.slug && <p className='error-message'>{errorMessage?.slug}</p>}
        </div>
      </div>
      <div className={`${styles.newPageRightRow}`} >
        <div className={`${styles.newPageRightTitle} ${styles.iconDropWrap}`} onClick={toggleDropdownPrice}>
          <span>Price</span>
          <div className={styles.dropdownIcon}>
            <img src={iconDropDown} alt="dropdown" />
          </div>
        </div>

        <div className={`${styles.contentDrop} ${isOpenPriceDropdown ? `${styles.expanded}` : `${styles.collapse}`}`}>
          <div className={`${styles.adressInputBlock} ${styles.urlInput}`}>
            <div className={styles.priceInputs}>
              <div className={styles.priceInputGroup}>
                <label>From</label>
                <input
                  type="number"
                  value={productData?.priceFrom}
                  onChange={(e) => {
                    setProductData({ ...productData, priceFrom: e.target.value });
                    setErrorMessage({ ...errorMessage, priceFrom: '' })
                  }}
                  onWheel={(e) => e.target.blur()}
                  placeholder="Enter price"
                  min={0}
                />
                {errorMessage?.priceFrom && <p className='error-message'>{errorMessage?.priceFrom}</p>}
              </div>
              <div className={styles.priceInputGroup}>
                <label>To</label>
                <input
                  type="number"
                  value={productData?.priceTo}
                  onChange={(e) => {
                    setProductData({ ...productData, priceTo: e.target.value });
                    setErrorMessage({ ...errorMessage, priceTo: '' })
                  }}
                  onWheel={(e) => e.target.blur()}
                  placeholder="Enter price"
                  min={0}
                />
                {errorMessage?.priceTo && <p className='error-message'>{errorMessage?.priceTo}</p>}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={`${styles.newPageRightRow}`} >
        <div className={`${styles.newPageRightTitle} ${styles.iconDropWrap}`} onClick={toggleDropdownUnit}>
          <span>Unit Singular / Plural</span>
          <div className={styles.dropdownIcon}>
            <img src={iconDropDown} alt="dropdown" />
          </div>
        </div>

        <div className={`${styles.contentDrop} ${isOpenUnitDropdown ? `${styles.expanded}` : `${styles.collapse}`}`}>
          <div className={`${styles.adressInputBlock} ${styles.stockManage}`}>
            <div className={styles.skuSection}>
              {/* <label>SKU</label> */}
              <input type="text" placeholder="Add Singular Unit" autoComplete="off"
                value={productData?.unit}
                onChange={(e) => {
                  setProductData({ ...productData, unit: e.target.value });
                  setErrorMessage({ ...errorMessage, unit: '' })
                }}
              />
            </div>
            {errorMessage?.unit && <p className='error-message'>{errorMessage?.unit}</p>}

            <div className={styles.skuSection} style={{ marginTop: 12 }}>
              <input type="text" placeholder="Add Unit Plural" autoComplete="off"
                value={productData?.unitPlural}
                onChange={(e) => {
                  setProductData({ ...productData, unitPlural: e.target.value });
                  setErrorMessage({ ...errorMessage, unitPlural: '' })
                }}
              />
            </div>
            {errorMessage?.unitPlural && <p className='error-message'>{errorMessage?.unitPlural}</p>}
          </div>
        </div>
      </div>
      <div className={`${styles.newPageRightRow}`} >
        <div className={`${styles.newPageRightTitle} ${styles.iconDropWrap}`} onClick={toggleDropdownSKU}>
          <span>SKU</span>
          <div className={styles.dropdownIcon}>
            <img src={iconDropDown} alt="dropdown" />
          </div>
        </div>

        <div className={`${styles.contentDrop} ${isOpenSKUDropdown ? `${styles.expanded}` : `${styles.collapse}`}`}>
          <div className={`${styles.adressInputBlock} ${styles.stockManage}`}>
            <div className={styles.skuSection}>
              {/* <label>SKU</label> */}
              <input type="text" placeholder="Add SKU" autoComplete="off"
                value={productData?.sku}
                onChange={(e) => {
                  setProductData({ ...productData, sku: e.target.value });
                  setErrorMessage({ ...errorMessage, sku: '' })
                }}
              />
            </div>
            {errorMessage?.sku && <p className='error-message'>{errorMessage?.sku}</p>}
            <div className={`${styles.skuWrapper} ${styles.skuSection}`}>
                <label>HSN Code</label>
                <input type="text" placeholder="Add HSN Code" autoComplete="off"
                value={productData?.hsnCode}
                onChange={(e) => {
                  setProductData({ ...productData, hsnCode: e.target.value });
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={`${styles.newPageRightRow}`} >
        <div className={`${styles.newPageRightTitle} ${styles.iconDropWrap}`} onClick={toggleDropdownShowProduct}>
          <span>Show Product</span>
          <div className={styles.dropdownIcon}>
            <img src={iconDropDown} alt="dropdown" />
          </div>
        </div>

        <div className={`${styles.contentDrop} ${isOpenShowProduct ? `${styles.expanded}` : `${styles.collapse}`}`}>
          <div className={`${styles.adressInputBlock} ${styles.stockManage}`}>
            <div className={styles.trackStock}>
              {/* <label>SKU</label> */}
              <input
                type="checkbox" checked={productData?.isPopular}
                onChange={(e) => {
                  setProductData({ ...productData, isPopular: e.target.checked });
                }}
              />
              <p>Is popular</p>
            </div>
            <div className={styles.trackStock}>
              {/* <label>SKU</label> */}
              <input
                type="checkbox" checked={productData?.isHotDeal}
                onChange={(e) => {
                  setProductData({ ...productData, isHotDeal: e.target.checked });
                }}
              />
              <p>Is Hot deal</p>
            </div>
            <div className={styles.trackStock}>
              {/* <label>SKU</label> */}
              <input
                type="checkbox" checked={productData?.isShowInList}
                onChange={(e) => {
                  setProductData({ ...productData, isShowInList: e.target.checked });
                }}
              />
              <p>Show in list</p>
            </div>
            <div className={styles.trackStock}>
              {/* <label>SKU</label> */}
              <input
                type="checkbox" checked={productData?.isBuilderChoice}
                onChange={(e) => {
                  setProductData({ ...productData, isBuilderChoice: e.target.checked });
                }}
              />
              <p>Builder’s Choice</p>
            </div>
            <div className={styles.trackStock}>
              {/* <label>SKU</label> */}
              <input
                type="checkbox" checked={productData?.isProPicks}
                onChange={(e) => {
                  setProductData({ ...productData, isProPicks: e.target.checked });
                }}
              />
              <p>Pro Picks</p>
            </div>
            <div className={styles.trackStock}>
              {/* <label>SKU</label> */}
              <input
                type="checkbox" checked={productData?.isTrendingNow}
                onChange={(e) => {
                  setProductData({ ...productData, isTrendingNow: e.target.checked });
                }}
              />
              <p>Trending Now</p>
            </div>
            <div className={styles.trackStock}>
              <input
                type="checkbox"
                name="isServiceProduct"
                checked={productData?.isServiceProduct || false}
                onChange={(e) => {
                  setProductData({ ...productData, isServiceProduct: e.target.checked });
                }}
              />
              <p>Is Service product</p>
            </div>
          </div>
        </div>
      </div>
      <div className={`${styles.newPageRightRow}`} >
        <div className={`${styles.newPageRightTitle} ${styles.iconDropWrap}`} onClick={toggleDropdownStock}>
          <span>Stock manage</span>
          <div className={styles.dropdownIcon}>
            <img src={iconDropDown} alt="dropdown" />
          </div>
        </div>

        <div className={`${styles.contentDrop} ${isOpenStockDropdown ? `${styles.expanded}` : `${styles.collapse}`}`}>
          <div className={`${styles.adressInputBlock} ${styles.stockManage}`}>
            <div className={styles.trackStock}>
              <input
                type="checkbox"
                checked={productData?.isTrackStock}
                onChange={(e) => {
                  setProductData({ ...productData, isTrackStock: e.target.checked });
                  setErrorMessage({ ...errorMessage, isTrackStock: '' })
                }}
              />
              <p>Track stock quantity for this product</p>
            </div>
            <div className={styles.quantitySection}>
              <label>Quantity</label>
              <input type="number" placeholder="0" autoComplete="off" min={0}
                value={productData?.quantity}
                onChange={(e) => {
                  setProductData({ ...productData, quantity: e.target.value });
                  setErrorMessage({ ...errorMessage, quantity: '' })
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={`${styles.newPageRightRow}`} >
        <div className={`${styles.newPageRightTitle} ${styles.iconDropWrap}`} onClick={toggleDropdownCategoryImage}>
          <span>Categories</span>
          <div className={styles.dropdownIcon}>
            <img src={iconDropDown} alt="dropdown" />
          </div>
        </div>

        <div className={`${styles.contentDrop} ${isOpenCategoryDropdown ? `${styles.expanded}` : `${styles.collapse}`}`}>
          <div className={`${styles.adressInputBlock} ${styles.urlInput}`}>
            <div className={`${styles.categoryPageSearch}`}>
              <img className="adressLink" src={search} alt="Search" />
              <input
                type="text"
                placeholder="Search"
                value={searchCategory}
                onChange={(e) => setSearchCategory(e.target.value)}
              />
            </div>
            <ul className={`${styles.listSearch} ${styles.categoriesList}`}>
              {
                filteredCategories.length > 0 ? (
                  filteredCategories.map((category) => (
                    <li key={category?.categoryId}>
                      <label>
                        <input
                          type="checkbox"
                          checked={selectedCategories?.includes(category)}
                          onChange={() => {
                            handleCheckboxChange(category);
                            setErrorMessage((prev) => ({ ...prev, category: "" }));
                          }}
                        />
                        <p>{category?.name}</p>
                      </label>
                    </li>
                  ))
                ) : (
                  <li>
                    <label>
                      <p>No data found</p>
                    </label>
                  </li>
                )
              }
            </ul>
            {errorMessage?.category && <p className='error-message'>{errorMessage?.category}</p>}
          </div>
        </div>
      </div>
      <div className={`${styles.newPageRightRow} ${styles.brandDropdown}`} >
        <div className={`${styles.newPageRightTitle} ${styles.iconDropWrap}`} onClick={toggleDropdownBrandCategoryImage}>
          <span>Brand</span>
          <div className={styles.dropdownIcon}>
            <img src={iconDropDown} alt="dropdown" />
          </div>
        </div>

        <div className={`${styles.contentDrop} ${isOpenBrandCategoryDropdown ? `${styles.expanded}` : `${styles.collapse}`}`}>
          <div className={`${styles.adressInputBlock} ${styles.urlInput}`}>
            <div className="dropdown-wrapper brand-dropdown" ref={dropdownRef}>
              <div className="dropdown-header" onClick={() => setOpenBrand(!openBrand)}>
                <span className="title">{selectedBrandCategories?.name || "Select Brand"}</span>
                <span className={`arrow ${openBrand ? "rotate" : ""}`}><img src={iconDropDown} alt='icon-dropdown' /></span>
              </div>
              {openBrand && (
                <div className="dropdown-list" >
                  <div className={`${styles.categoryPageSearch}`}>
                    <img className="adressLink" src={search} alt="Search" />
                    <input
                      type="text"
                      placeholder="Search"
                      value={searchBrand}
                      onChange={(e) => setSearchBrand(e.target.value)}
                    />
                  </div>
                  {
                    filteredBrands.length > 0 ? (
                      filteredBrands.map((item) => (
                        <label
                          key={item?.id || item?.name} // better than index
                          className="dropdown-item"
                          onClick={() => {
                            handleBrandCategoryCheckboxChange(item);
                            setOpenBrand(false);
                            setErrorMessage((prev) => ({ ...prev, brand: '' }));
                            setSearchBrand('');
                          }}
                        >
                          <span>{item?.name}</span>
                        </label>
                      ))
                    ) : (
                      <label className="dropdown-item">
                        <span>No data found</span>
                      </label>
                    )
                  }
                </div>
              )}
              {errorMessage?.brand && <p className='error-message'>{errorMessage?.brand}</p>}
            </div>
          </div>
        </div>
      </div>
      <div className={`${styles.newPageRightRow}`}>
        <div className={`${styles.newPageRight}`}>
          <div className={`${styles.newPageRightTitle} ${styles.iconDropWrap} ${styles.imageUpload}`} onClick={toggleDropdownFeatureImage}>
            <span>Featured image</span>
            <div className={`${styles.dropdownIcon}`}>
              <img src={iconDropDown} alt="dropdown" />
            </div>
          </div>

          <div className={`${styles.contentDrop} ${isOpenFeatureImageDropdown ? `${styles.expanded}` : `${styles.collapse}`}`}>
            <div>
              <div className={`${styles.newPageRightRow} ${styles.imageUploadBox} ${isImageDragging ? styles.draging : ''}`}
                onDragOver={handleFileDragOver}
                onDragLeave={handleFileDragLeave}
                onDrop={handleFeatureImageDrop}
                onClick={(e) => { e.stopPropagation(); setShowUploadMediaPopup(true); setUploadMediaPopupFor('feature-image'); setUploadMediaPopupTab('media'); }}>
                {(featuredImageArray[0] || selectedFeatureImage) ? (
                  featuredImageArray[0]?.isLoading ? (
                    <div className={styles.progressWrap}>
                      <div className={styles.progress}>
                        <div className={styles.color}></div>
                      </div>
                    </div>
                  ) : (
                    <img src={(featuredImageArray[0] || selectedFeatureImage)?.url} className={`${styles.featuredImg}`} alt='feature-image' />
                  )
                )
                  : (
                    <>
                      <div id="newpageImageUpload" className={`${styles.newpageImageUpload}`}>
                        <div className={`${styles.featureImgMiddleContent}`}>
                          <img className={`${styles.fileUploadCover_Img}`} src={featured} alt="FeaturedImage" />
                          <p className={`${styles.newPageImageUploadText}`}>
                            <span onClick={(e) => { e.stopPropagation(); setShowUploadMediaPopup(true); setUploadMediaPopupFor('feature-image'); setUploadMediaPopupTab('media'); }}>Upload</span> or <span onClick={(e) => { e.stopPropagation(); setShowUploadMediaPopup(true); setUploadMediaPopupFor('feature-image'); setUploadMediaPopupTab('media'); }}>Open Media Library</span>
                            <br />
                            JPG, PNG (max. 128MB)
                          </p>
                        </div>
                      </div>
                      <input type="file" id="feature-img" accept="image/*" hidden />
                    </>
                  )
                }
              </div>
            </div>
          </div>
          {errorMessage?.image && <p className='error-message'>{errorMessage?.image}</p>}
        </div>

      </div>
      <div className={styles.buttonsMobile}>
        {(published === false && draft === false) ? (
          <div className={styles.newpageRightButtons}>
            <button
              className={`${styles.primaryButton} ${styles.publishButton}`}
              onClick={handlePublish}
            >
              {isLoading ? (
                <div className={styles.ringLoader}></div>
              ) : (
                <p>Publish</p>
              )}
            </button>
            <button
              className={`${styles.secondaryButton} ${styles.draftButton}`}
              onClick={() => { if (!validateDraftProduct()) return; setIsDraftLoading(true); handleDraft(); }}
            >
              {isDraftLoading ? (
                <div className={styles.ringLoader}></div>
              ) : (
                <p>Save as draft</p>
              )}
            </button>
          </div>
        ) : published === true ? (
          <div>
            <div className={styles.newpageRightButtons} ref={dotsMobileRef}>
              <button
                className={`${styles.primaryButton} ${styles.updatePagebtn}`}
                onClick={handlePublish}
              >
                {isLoading ? (
                  <div className={styles.ringLoader}></div>
                ) : (
                  <p>Update</p>
                )}
              </button>
              <button
                className={`${styles.newpageMoreButtons} ${styles.secondaryButton}`}
                onClick={() => setIsPublishedOpen(!isPublishedOpen)}
              >
                <img src={more} alt="Dots" className={`actionDots ${styles.actionDots}`} />
              </button>
              {isPublishedOpen && productId && (
                <div className={`publishedButtonsList ${styles.publishedButtonsList}`}>
                  <ul>
                    <li
                      className={styles.publishLi}
                      onClick={handleChangeToDraft}
                    >
                      Change to draft
                    </li>
                    <li
                      className={styles.publishLi}
                      onClick={handleSingleDelete}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              )}
            </div>
            <p className={styles.publishStatus}>
              Status: <span>{productData?.status?.charAt(0).toUpperCase() + productData?.status?.slice(1)}</span>
            </p>
          </div>
        ) : draft === true ? (
          <div>
            <div className={styles.newpageRightButtons} ref={dotsMobileRef}>
              <button
                className={`${styles.primaryButton} ${styles.updateDraftButton}`}
                onClick={() => {
                  if (!validateDraftProduct()) return;
                  setIsLoading(true);
                  handleDraft();
                }}
              >
                {isLoading ? (
                  <div className={styles.ringLoader}></div>
                ) : (
                  <p>Update Draft</p>
                )}
              </button>
              <button
                className={`${styles.newpageMoreButtons} ${styles.secondaryButton}`}
                onClick={() => setIsDraftOpen(!isDraftOpen)}
              >
                <img src={more} alt="Dots" className={`actionDots ${styles.actionDots}`} />
              </button>
              {isDraftOpen && productId && (
                <div className={`publishedButtonsList ${styles.publishedButtonsList}`}>
                  <ul>
                    <li
                      className={styles.publishLi}
                      onClick={handleChangeToPublish}
                    >
                      Publish
                    </li>
                    <li
                      className={styles.publishLi}
                      onClick={handleSingleDelete}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              )}
            </div>
            <p className={styles.publishStatus}>
              Status: <span className={styles.draftStatus}>Draft</span>
            </p>
          </div>
        ) : (
          ''
        )}

      </div>
    </div>
  )
}
